import EditorPanelButton from "./EditorPanelButton";
import {useCallback} from "react";
import useObjectEditStore from "../../../store/useObjectEditStore";
import IconDelete from "../../../public/images/delete-2.svg";
import useEditorStore from "../../../store/useEditorStore";

const BoldButton = () => {
  const store = useEditorStore();
  const objectEditStore = useObjectEditStore();

  const handleDeleteClick = useCallback(() => {
    objectEditStore.setObjectEdit(objectEditStore.objectEdit.element.remove());
    store.setIsEditing(false);
  }, []);

  return (
    <EditorPanelButton onClick={handleDeleteClick} icon={IconDelete}/>
  );
};

export default BoldButton;
